import { Link } from "react-router-dom";
import { useScrollAnimation } from "@/hooks/useScrollAnimation";

export default function StoreInfoSection() {
  const leftAnim = useScrollAnimation({ threshold: 0.1 });
  const rightAnim = useScrollAnimation({ threshold: 0.1 });

  return (
    <section id="store-info" className="bg-[#f5ede4] py-20 md:py-28 overflow-hidden">
      <div className="w-full px-6 md:px-16 max-w-[1400px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          {/* Left */}
          <div
            ref={leftAnim.ref as React.RefObject<HTMLDivElement>}
            className={`transition-all duration-800 ${leftAnim.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}
          >
            <p className="text-[#8B5E52] text-[1rem] tracking-[0.25em] uppercase font-medium mb-3">Store Info</p>
            <h2 className="text-[#3d2b1f] text-[2.125rem] md:text-[2.5rem] font-bold leading-[1.4] mb-6">台中實體門市</h2>
            <p className="text-[#7a6455] text-[1.1875rem] leading-[1.75] mb-8">歡迎親自來店體驗每件衣服的質感與版型。我們的專業造型顧問將為您提供一對一的穿搭建議，讓您找到最適合自己的優雅風格。</p>

            <div className="flex flex-col gap-5 mb-8">
              {[
                { icon: "ri-map-pin-2-line", label: "地址", value: "台中市西屯區台灣大道三段XXX號（近捷運台灣大道站）" },
                { icon: "ri-phone-line", label: "電話", value: "04-XXXX-XXXX" },
                { icon: "ri-time-line", label: "營業時間", value: "週二至週日 11:00–19:30｜週一公休" },
                { icon: "ri-car-line", label: "停車資訊", value: "門市附近設有公共停車場，停車便利" },
              ].map((item, i) => (
                <div key={i} className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#c9a98a]/25 flex-shrink-0">
                    <i className={`${item.icon} text-[#8B5E52] text-lg`}></i>
                  </div>
                  <div>
                    <p className="text-[#3d2b1f] text-[1rem] font-semibold">{item.label}</p>
                    <p className="text-[#7a6455] text-[1.0625rem] leading-relaxed">{item.value}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row gap-3">
              <Link to="/contact" className="inline-flex items-center justify-center gap-2 px-7 py-3.5 bg-[#3d2b1f] text-[#faf8f5] rounded-full text-[1.0625rem] font-semibold hover:bg-[#8B5E52] transition-colors cursor-pointer whitespace-nowrap">
                <i className="ri-calendar-line"></i> 預約試穿
              </Link>
              <a href="https://line.me" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 px-7 py-3.5 border-2 border-[#3d2b1f] text-[#3d2b1f] rounded-full text-[1.0625rem] font-semibold hover:bg-[#3d2b1f] hover:text-[#faf8f5] transition-colors cursor-pointer whitespace-nowrap">
                <i className="ri-line-fill"></i> LINE 線上諮詢
              </a>
            </div>
          </div>

          {/* Right */}
          <div
            ref={rightAnim.ref as React.RefObject<HTMLDivElement>}
            className={`rounded-lg overflow-hidden transition-all duration-800 delay-150 ${rightAnim.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}
          >
            <div className="w-full h-[380px] rounded-lg relative overflow-hidden">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3640.5!2d120.6478!3d24.1694!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjTCsDEwJzEwLjAiTiAxMjDCsDM4JzUyLjEiRQ!5e0!3m2!1szh-TW!2stw!4v1"
                width="100%" height="100%" style={{ border: 0 }} allowFullScreen loading="lazy"
                referrerPolicy="no-referrer-when-downgrade" title="門市地圖" className="rounded-lg"
              />
            </div>
            <div className="mt-4 rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=elegant%20women%20fashion%20boutique%20interior%20warm%20cream%20beige%20tones%20clothing%20rack%20minimalist%20luxury%20store%20atmosphere%20soft%20natural%20light%20designer%20brand%20quality&width=800&height=300&seq=store001&orientation=landscape"
                alt="門市環境"
                className="w-full h-[200px] object-cover object-top rounded-lg"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
